const info = {
  ZH: { //中文翻译
    maintitle: "\u4E2D\u56FD\u6C7D\u8F66\u6750\u6599\u6570\u636E\u7CFB\u7EDF",
    script_datenull: "\u8BF7\u8F93\u5165\u65F6\u95F4\uFF01",
    chenck_datatype: "\u65E5\u671F\u8BF7\u6309YYYY-MM-DD\u7C7B\u578B\u8F93\u5165",
    check_dateFromTo: "\u5F00\u59CB\u65E5\u671F\u5FC5\u987B\u5C0F\u4E8E\u7ED3\u675F\u65E5\u671F",
    check_materialName: "\u8BF7\u8F93\u5165\u7269\u8D28\uFF01",
    statusTitle: "\u5206\u6790",
    title: "\u5206\u6790",
    radio1: "\u6709\u5BB3\u7269\u8D28\u5206\u6790",
    radio2: "MDS\u4E2D\u542B\u6709\u67D0\u7269\u8D28\u5206\u6790",
    radio3: "\u5E94\u7528\u9009\u9879\u5206\u6790",
    checkbox1: "\u5DF2\u53D1\u5E03\u7684\:",
    fromdata: '\u5F00\u59CB\u65E5\u671F\:<span style\:""color\: red;">*</span>',
    todate: '\u7ED3\u675F\u65E5\u671F\:<span style\:""color\: red;">*</span>',
    yearday: "[\u5E74(4\u4F4D)-\u6708(2\u4F4D)-\u65E5(2\u4F4D)]",
    cmeaReuseRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    cmeaReuseRateIsNull: "\u8BF7\u8F93\u5165\u6D4B\u91CF\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\uFF01",
    ccalReuseRate: "\u8BA1\u7B97\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387",
    ccalReuseRateIsNull: "\u8BF7\u8F93\u5165\u8BA1\u7B97\u6240\u5F97\u53EF\u518D\u5229\u7528\u7387\uFF01",
    cmeaRecycleRate: "\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    cmeaRecycleRateIsNull: "\u8BF7\u8F93\u5165\u6D4B\u91CF\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\uFF01",
    ccalRecycleRate: "\u8BA1\u7B97\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387",
    ccalRecycleRateIsNull: "\u8BF7\u8F93\u5165\u8BA1\u7B97\u6240\u5F97\u53EF\u56DE\u6536\u5229\u7528\u7387\uFF01",
    equal: "\u7B49\u4E8E",
    than: "\u5927\u4E8E",
    less: "\u5C0F\u4E8E",
    lessequal: "\u5C0F\u4E8E\u7B49\u4E8E",
    greaterequal: "\u5927\u4E8E\u7B49\u4E8E",
    contain: "\u542B\u6709",
    ccas_code: "CAS\u7F16\u53F7",
    material: "\u7269\u8D28",
    gadsl: "\u542B\u6709GADSL\u4E2DD\u3001P\u3001P/D\u7269\u8D28",
    gadsl1: "\u542B\u6709GADSL\u4E2DD\u3001P\u3001D/P\u7269\u8D28",
    confidentialmaterial: "\u542B\u6709\u4FDD\u5BC6\u7269\u8D28",
    serch: "\u67E5\u627E",
    serch_to: "\u663E\u793A",
    num: "\u6761,",
    prepage: "\u4E0A\u4E00\u9875",
    nextpage: "\u4E0B\u4E00\u9875",
    productname: "\u4EA7\u54C1\u540D\u79F0",
    mdsType:'产品类型',
    receptionTime:'接收时间',
    entry: "\u96F6\u90E8\u4EF6\u53F7,\u534A\u6210\u54C1\u4EF6\u53F7,\u6750\u6599\u53F7",
    idandver: "ID/\u7248\u672C",
    supplier: "\u4F9B\u5E94\u5546",
    checkbox2: "\u672C\u4F01\u4E1A\u7684\:",
    sendTable: ">> MDS\u56DE\u6536\u6027\u5206\u6790",
    check_rate: "\u8BF7\u81F3\u5C11\u8F93\u5165\u4E00\u4E2A\u5229\u7528\u7387\uFF01",
    searchfor: "\u67E5\u8BE2\u5230",
    serialnumber: "\u5E8F\u53F7",
    pisokpage: "\u8BF7\u8F93\u5165\u6B63\u786E\u9875\u7801",
    check_num: "\u8BF7\u586B\u5199\u6B63\u786E\u683C\u5F0F\u7684\u5229\u7528\u7387",
    view: "\u67E5\u770B",
    mustSelect: "\u8BF7\u5148\u9009\u62E9\u4E00\u4E2A\u67E5\u8BE2\u7ED3\u679C",
    svhc: '\u542B\u6709REACH-SVHC ',
    applivali: '\u5E94\u7528\u9009\u9879\u6709\u6548\u6027\uFF1A',
    exempt: '\u5F53\u524D\u53EF\u9009',
    overdue: '\u5DF2\u8FC7\u671F',
    number: '\u5E8F\u53F7',
    applicationDetail: '\u5E94\u7528\u9009\u9879\u63CF\u8FF0',
    substance: '\u5BF9\u5E94\u7269\u8D28',
    valiFlag: '\u9009\u9879\u6709\u6548\u6027',
    analyse: '\u5206\u6790',
    export: 'u5BFC\u51FA',
    select: '\u9009\u62E9',
    cancel: '\u53D6\u6D88',
    applicationOptions: '应用选择',
    noDataNull:"无相关分析数据！",
    message1:'\u96F6\u90E8\u4EF6\u7684\u8D28\u91CF\u4E3A\u96F6\uFF01',
    message2:"\u6CA1\u6709\u6570\u636E,\u8BF7\u70B9\u9009\u62E9\u952E\uFF01",
    csymbol:"\u96F6\u90E8\u4EF6/\u534A\u6210\u54C1/\u6750\u6599\u53F7",
    createTime:"\u521B\u5EFA\u65F6\u95F4"
  },
  EN: { //英文翻译
    maintitle: "China Automotive Material Data System (CAMDS)",
    script_datenull: "Please input time!",
    chenck_datatype: "The type of date shall be YYYY-MM-DD when entering",
    check_dateFromTo: "The start date must be earlier than the end date",
    check_materialName: "Please input the name of material!",
    statusTitle: "Analyze",
    title: "Analyze",
    radio1: "MDS hazardous analysis",
    radio2: "MDS substance Analysis",
    radio3: "Application options analysis",
    checkbox1: "Published\:",
    fromdata: 'From\:<span style\:""color\: red;">*</span>',
    todate: 'To\:<span style\:""color\: red;">*</span>',
    yearday: "[Year(four digits)-Month(two digits)-Day(two digits)]",
    opertation: 'Recoverability rate\:<span style\:""color\: red;">*</span>',
    equal: "Equal to",
    than: "Larger than",
    less: "Less than",
    lessequal: "Less than or equal to",
    greaterequal: "Larger than or equal to",
    contain: "Substance ",
    material: "",
    gadsl: "D, P, and P/D substance in the GADSL",
    gadsl1: "D, P, and D/p substance in the GADSL",
    confidentialmaterial: "	confidential substance",
    serch: "Search",
    analyse: "Analyse",
    serch_to: "Display",
    num: "Item",
    prepage: "Previous Page",
    nextpage: "Next Page",
    productname: "product name",
    mdsType:'Product Type',
    receptionTime:'Reception time',
    entry: "Component No., Semicomponent No., Material No.",
    idandver: "ID/Version",
    supplier: "Supplier",
    checkbox2: "Own",
    sendTable: ">> MDS recovery analysis",
    check_rate: "Please input the utilization rate!",
    searchfor: "Search for",
    cmeaReuseRate: "Measured Recyclability Rate",
    ccalReuseRate: "Calculated Recyclability Rate",
    cmeaRecycleRate: "Measured Recoverability Rate",
    ccalRecycleRate: "Calculated Recoverability Rate",
    serialnumber: "NO.",
    check_num: "The utilization rate must be a number.",
    view: "view",
    mustSelect: "Please select a query result first\!",
    ccas_code: "CAS",
    svhc: 'REACH-SVHC',
    applivali: 'validity',
    exempt: 'visible',
    overdue: 'obsolete',
    number: 'Number',
    applicationDetail: 'Description of application options',
    substance: 'Corresponding substance',
    valiFlag: 'Option validity',
    applicationOptions: 'Application Options',
    export: 'export',
    select: 'Select',
    cancel: 'Cancel',
    noDataNull:"No relevant analytical data!",
    message1:'Component weight is Zero',
    message2:"No data. Please click on the Option key!",
    csymbol:"Component No., Semicomponent No., Material No.",
    createTime:"Create Time"
  }
}
export default info //需要暴露出去
